
$( document ).ready(function() {
    $('#product-builder').css('margin-top',$('#shopify-section-header').height()+30);
});
$(document).on("click", ".cpb-option" , function() {
   
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field1')){
           $('.engraving_Field1').addClass('show_eng_field1');
        }

        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field2')){
          $('.engraving_Field2').addClass('show_eng_field2');
        }
                 
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field3')){
          $('.engraving_Field3').addClass('show_eng_field3');
        }
                 
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field4')){
          $('.engraving_Field4').addClass('show_eng_field4');
        }  
                 
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field5')){
          $('.engraving_Field5').addClass('show_eng_field5');
        }  
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field6')){
          $('.engraving_Field6').addClass('show_eng_field6');
        }
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field7')){
          $('.engraving_Field7').addClass('show_eng_field7');
        } 
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field8')){
          $('.engraving_Field8').addClass('show_eng_field8');
        } 
});
 
                 
 $(document).on("click", ".eng_field1 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field1')){
       $('.engraving_Field1').addClass('block1_clk_show_eng_field1');
        
    }else {
       $('.engraving_Field1').removeClass('block1_clk_show_eng_field1');
    }            
 });

 $(document).on("click", ".eng_field2 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field2')){
       $('.engraving_Field2').addClass('block1_clk_show_eng_field2');
    }else {
       $('.engraving_Field2').removeClass('block1_clk_show_eng_field2');
    }            
 });
 
 $(document).on("click", ".eng_field3 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field3')){
       $('.engraving_Field3').addClass('block1_clk_show_eng_field3');
    }else {
       $('.engraving_Field3').removeClass('block1_clk_show_eng_field3');
    }              
 });
 
  $(document).on("click", ".eng_field4 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field4')){
       $('.engraving_Field4').addClass('block1_clk_show_eng_field4');
    }else {
       $('.engraving_Field4').removeClass('block1_clk_show_eng_field4');
    }              
 });
                 
   $(document).on("click", ".eng_field5 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field5')){
       $('.engraving_Field5').addClass('block1_clk_show_eng_field5');
    }else {
       $('.engraving_Field5').removeClass('block1_clk_show_eng_field5');
    }              
 });
                 
                 $(document).on("click", ".eng_field6 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field6')){
       $('.engraving_Field6').addClass('block1_clk_show_eng_field6');
    }else {
       $('.engraving_Field6').removeClass('block1_clk_show_eng_field6');
    }              
 });
                 
                 $(document).on("click", ".eng_field7 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field7')){
       $('.engraving_Field7').addClass('block1_clk_show_eng_field7');
    }else {
       $('.engraving_Field7').removeClass('block1_clk_show_eng_field7');
    }              
 });
                 
                 
    $(document).on("click", ".eng_field8 .cpb-category-title" , function() {
    if($(this).parent().is('.cpb-category-collapse-active.eng_field8')){
       $('.engraving_Field8').addClass('block1_clk_show_eng_field8');
    }else {
       $('.engraving_Field8').removeClass('block1_clk_show_eng_field8');
    }              
 });
                 
                 
         $(document).on("click", ".cpb-category" , function() {
                 //alert('yes');
            var spans_Cpb_active = $(this).children().next('.cpb-category-content').children().next('.cpb-category-options-container').children().children();
                 var spans1 = $(this).parent();
                 
                 console.log(spans_Cpb_active);//cpb-active
                 if($(this).hasClass('eng_field1'))
                 {
                 	console.log('block1');
                 	// $('.engraving_Field1').addClass('block1_clk_show_eng_field1');
                 	/*$('.eng_field1 .cpb-category-content').css("display", "block");
                 	$('.eng_field2 .cpb-category-content').css("display", "none");
                 	$('.eng_field3 .cpb-category-content').css("display", "none");
                 	$('.eng_field4 .cpb-category-content').css("display", "none");*/
                 
                 	/*if(spans_Cpb_active.hasClass('cpb-active'))
                 	{
                 		//$('.engraving_Field1').addClass('show_eng_field1');
                 	}else{
                        $('.engraving_Field4').removeClass('show_eng_field4');
                        $('.engraving_Field3').removeClass('show_eng_field3');
                        $('.engraving_Field2').removeClass('show_eng_field2');
                 	}*/
                 
                 }
                 if($(this).hasClass('eng_field2'))
                 {
                 	console.log('block2');
                 	/*$('.eng_field2 .cpb-category-content').css("display", "block");
                 	$('.eng_field1 .cpb-category-content').css("display", "none");
                 	$('.eng_field3 .cpb-category-content').css("display", "none");
                 	$('.eng_field4 .cpb-category-content').css("display", "none");*/
                 	 
                 	/*if(spans_Cpb_active.hasClass('cpb-active'))
                 	{
                 		 //$('.engraving_Field2').addClass('show_eng_field2');
                 	}else{
                         $('.engraving_Field4').removeClass('show_eng_field4');
                         $('.engraving_Field3').removeClass('show_eng_field3');
                         $('.engraving_Field1').removeClass('show_eng_field1');
                    }*/
                 
                 }
                 if($(this).hasClass('eng_field3'))
                 {
                 	console.log('block3');
                 	/*$('.eng_field3 .cpb-category-content').css("display", "block");
                 	$('.eng_field1 .cpb-category-content').css("display", "none");
                 	$('.eng_field2 .cpb-category-content').css("display", "none");
                 	$('.eng_field4 .cpb-category-content').css("display", "none");*/
                 
                 	/*if(spans_Cpb_active.hasClass('cpb-active'))
                 	{
                 		 //$('.engraving_Field3').addClass('show_eng_field3');
                 	}else{
                         $('.engraving_Field4').removeClass('show_eng_field4');
                         $('.engraving_Field2').removeClass('show_eng_field2');
                         $('.engraving_Field1').removeClass('show_eng_field1');
                    }*/
                 
                 }
                 if($(this).hasClass('eng_field4'))
                 {
                   //console.log(spans);
                 	console.log('block4');
                 	/*$('.eng_field4 .cpb-category-content').css("display", "block");
                 	$('.eng_field2 .cpb-category-content').css("display", "none");
                 	$('.eng_field3 .cpb-category-content').css("display", "none");
                 	$('.eng_field1 .cpb-category-content').css("display", "none");*/
                 	/*if(spans_Cpb_active.hasClass('cpb-active'))
                 	{
                 		 //$('.engraving_Field4').addClass('show_eng_field4');
                 	}else{
                         $('.engraving_Field3').removeClass('show_eng_field3');
                         $('.engraving_Field2').removeClass('show_eng_field2');
                         $('.engraving_Field1').removeClass('show_eng_field1');
                    }*/
                 
                 }
                 
			//$(this).children().find(spans).css("display", "none"); 
         });
                 
                 
                 
                 
                 
                 
                 
    $(document).on("click", ".cpb-option" , function() {   
        if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field1')){
           $('.mac_field1').addClass('show_mac_field1');
        }
       if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field2')){
           $('.mac_field2').addClass('show_mac_field2');
        }
      if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field3')){
           $('.mac_field3').addClass('show_mac_field3');
        }
      if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field4')){
           $('.mac_field4').addClass('show_mac_field4');
        }
      if($(this).parent().parent().parent().parent().is('.cpb-category-collapse-active.eng_field5')){
           $('.mac_field5').addClass('show_mac_field5');
        }
      
     });
     $(document).on("click", '.show_mac_field1 .cpb-option-tooltip-img[alt="None"]' , function() {          
           $('.engraving_Field1 .cpb-option-type-input__wrapper').removeClass('serif');      
        $('.engraving_Field1 .cpb-option-type-input__wrapper').removeClass('script'); 
     });                               
     $(document).on("click", '.show_mac_field1 .cpb-option-tooltip-img[alt="Script"]' , function() {          
           $('.engraving_Field1 .cpb-option-type-input__wrapper').addClass('script');  
           $('.engraving_Field1 .cpb-option-type-input__wrapper').removeClass('serif');
     });            
     $(document).on("click", '.show_mac_field1 .cpb-option-tooltip-img[alt="Serif"]' , function() {          
           $('.engraving_Field1 .cpb-option-type-input__wrapper').addClass('serif');      
        $('.engraving_Field1 .cpb-option-type-input__wrapper').removeClass('script');  
     });      

  
     $(document).on("click", '.show_mac_field2 .cpb-option-tooltip-img[alt="None"]' , function() {          
           $('.engraving_Field2 .cpb-option-type-input__wrapper').removeClass('serif');      
        $('.engraving_Field2 .cpb-option-type-input__wrapper').removeClass('script'); 
     });                               
     $(document).on("click", '.show_mac_field2 .cpb-option-tooltip-img[alt="Script"]' , function() {          
           $('.engraving_Field2 .cpb-option-type-input__wrapper').addClass('script');  
           $('.engraving_Field2 .cpb-option-type-input__wrapper').removeClass('serif');
     });            
     $(document).on("click", '.show_mac_field2 .cpb-option-tooltip-img[alt="Serif"]' , function() {          
           $('.engraving_Field2 .cpb-option-type-input__wrapper').addClass('serif');      
        $('.engraving_Field2 .cpb-option-type-input__wrapper').removeClass('script');  
     });
                 

  $(document).on("click", '.show_mac_field3 .cpb-option-tooltip-img[alt="None"]' , function() {          
           $('.engraving_Field3 .cpb-option-type-input__wrapper').removeClass('serif');      
        $('.engraving_Field3 .cpb-option-type-input__wrapper').removeClass('script'); 
     });                               
     $(document).on("click", '.show_mac_field3 .cpb-option-tooltip-img[alt="Script"]' , function() {          
           $('.engraving_Field3 .cpb-option-type-input__wrapper').addClass('script');  
           $('.engraving_Field3 .cpb-option-type-input__wrapper').removeClass('serif');
     });            
     $(document).on("click", '.show_mac_field3 .cpb-option-tooltip-img[alt="Serif"]' , function() {          
           $('.engraving_Field3 .cpb-option-type-input__wrapper').addClass('serif');      
        $('.engraving_Field3 .cpb-option-type-input__wrapper').removeClass('script');  
     });

  $(document).on("click", '.show_mac_field4 .cpb-option-tooltip-img[alt="None"]' , function() {          
           $('.engraving_Field4 .cpb-option-type-input__wrapper').removeClass('serif');      
        $('.engraving_Field4 .cpb-option-type-input__wrapper').removeClass('script'); 
     });                               
     $(document).on("click", '.show_mac_field4 .cpb-option-tooltip-img[alt="Script"]' , function() {          
           $('.engraving_Field4 .cpb-option-type-input__wrapper').addClass('script');  
           $('.engraving_Field4 .cpb-option-type-input__wrapper').removeClass('serif');
     });            
     $(document).on("click", '.show_mac_field4 .cpb-option-tooltip-img[alt="Serif"]' , function() {          
           $('.engraving_Field4 .cpb-option-type-input__wrapper').addClass('serif');      
        $('.engraving_Field4 .cpb-option-type-input__wrapper').removeClass('script');  
     });

  $(document).on("click", '.show_mac_field5 .cpb-option-tooltip-img[alt="None"]' , function() {          
           $('.engraving_Field5 .cpb-option-type-input__wrapper').removeClass('serif');      
        $('.engraving_Field5 .cpb-option-type-input__wrapper').removeClass('script'); 
     });                               
     $(document).on("click", '.show_mac_field5 .cpb-option-tooltip-img[alt="Script"]' , function() {          
           $('.engraving_Field5 .cpb-option-type-input__wrapper').addClass('script');  
           $('.engraving_Field5 .cpb-option-type-input__wrapper').removeClass('serif');
     });            
     $(document).on("click", '.show_mac_field5 .cpb-option-tooltip-img[alt="Serif"]' , function() {          
           $('.engraving_Field5 .cpb-option-type-input__wrapper').addClass('serif');      
        $('.engraving_Field5 .cpb-option-type-input__wrapper').removeClass('script');  
     });
  